import React from "react";
import { Link } from "react-router-dom";

const KnowledgeCard = ({ knowledge }) => {
  const {
    knowledge_id,
    title,
    content,
    main_img_url,
    catkm_name,
    views,
    rating,
    rating_count,
    publish_date,
  } = knowledge;

  const defaultImage = "/assets/knowledge/no-img.png";
  const imageUrl = main_img_url || defaultImage;

  const renderStars = () => {
    const ratingValue = parseFloat(rating) || 0;
    const fullStars = Math.floor(ratingValue);
    const hasHalfStar = ratingValue - fullStars >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    return (
      <>
        {[...Array(fullStars)].map((_, i) => (
          <i key={`full-${i}`} className="fas fa-star text-yellow-400"></i>
        ))}
        {hasHalfStar && (
          <i className="fas fa-star-half-alt text-yellow-400"></i>
        )}
        {[...Array(emptyStars)].map((_, i) => (
          <i key={`empty-${i}`} className="far fa-star text-yellow-400"></i>
        ))}
      </>
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("th-TH", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all hover:-translate-y-2">
      <Link to={`/knowledge/${knowledge_id}`} className="block">
        <div className="relative h-48 overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover transition-transform hover:scale-110"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = defaultImage;
            }}
          />
          {catkm_name && (
            <span className="absolute bottom-2 left-2 bg-primary-500 text-white text-xs px-2 py-1 rounded-full">
              <i className="fas fa-folder mr-1"></i>
              {catkm_name}
            </span>
          )}
        </div>

        <div className="p-4">
          <h3 className="font-semibold text-gray-800 mb-2 line-clamp-2 h-12">
            {title}
          </h3>

          <p className="text-gray-600 text-sm mb-3 line-clamp-2">
            {content?.replace(/<[^>]*>/g, "").substring(0, 80)}...
          </p>

          <div className="flex items-center gap-2 mb-3">
            <div className="flex">{renderStars()}</div>
            <span className="text-xs text-gray-500">
              {rating} ({rating_count || 0})
            </span>
          </div>

          <div className="flex justify-between items-center text-xs text-gray-500 pt-3 border-t">
            <span>
              <i className="fas fa-eye mr-1 text-primary-500"></i>
              {views || 0}
            </span>
            <span>
              <i className="fas fa-calendar-alt mr-1 text-primary-500"></i>
              {formatDate(publish_date)}
            </span>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default KnowledgeCard;
